import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  userData: null,
  token: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const {setUserData, setToken} = userSlice.actions;

const userReducer = userSlice.reducer;

export default userReducer;
